import { Divider, Form, Input } from "antd";
import { FC, ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { withFloatingLabel } from "src/HOC/WithFloatingLabel";
import Carrier from "@Components/Carrier/Carrier";
import { PassengerIcon, ClassIcon, PassengerClassIcon } from "src/assets/Icons";
import { PASSENGER_CLASSES, INITIAL_PASSENGERS, INITIAL_CLASS, PassengersType } from "../../../constants";
import { countPassengers } from "../PassengerSelection/utils";
import PassengerSelectContent from "../PassengerSelectContent/PassengerSelectContent";
import ClassSelectContent from "../ClassSelectContent/ClassSelectContent";

const FloatingInput = withFloatingLabel(Input);

type PassengerClassSelectionProps = {
  label?: ReactNode;
};

const PassengerClassSelection: FC<PassengerClassSelectionProps> = ({ label }) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const passengers: PassengersType = Form.useWatch("passengers", form) ?? INITIAL_PASSENGERS;
  const flightCabinClass: number = Form.useWatch("flightCabinClass", form) ?? INITIAL_CLASS.key;

  const numberOfPassengers = countPassengers(passengers);
  const passengersLabel = `${numberOfPassengers} ${numberOfPassengers === 1 ? t("Flights.search.passenger") : t("Flights.search.passengers")}`;
  const classLabel = PASSENGER_CLASSES.find((passengerClass) => passengerClass.key === flightCabinClass)?.label;
  const displayValue = [passengersLabel, classLabel].filter(Boolean).join(", ");

  return Carrier({
    label,
    renderTrigger: ({ open }) => (
      <div className={`border-b border-border-default flex w-full flex-1 items-center gap-1 px-1`}>
        <PassengerClassIcon className="text-font-minimal" />
        <FloatingInput
          label={label}
          readOnly
          value={displayValue}
          className="outline-none! border-none! pt-5! pb-1! px-3! gap-4! font-semibold!"
          classNames={{
            label:"text-font-minimal!"
          }}
          onClick={open}
        />
      </div>
    ),
    renderSheet: () => (
      <div className="flex h-full flex-col gap-6 overflow-y-auto p-4">
        <div className="flex flex-col">
          <div className="flex items-center gap-2 font-bold">
            <PassengerIcon />
            {t("Flights.search.passengers")}
          </div>
          <PassengerSelectContent />
        </div>
        <Divider orientation="horizontal" className="m-0!"/>

        <div className="flex flex-col">
          <div className="flex items-center gap-2 font-bold">
            <ClassIcon />
            {t("Flights.search.class")}
          </div>
          <ClassSelectContent />
        </div>
      </div>
    ),
  });
};

export default PassengerClassSelection;
